module.exports = __webpack_public_path__ + "img/content5.71b52247.png";